import React, { Suspense, lazy, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch, useLocation } from "react-router-dom";
import HomePage from "./pages/index";
import TopNav from "./Components/TopNav";
import Footer from "./Components/Footer";
import SiteSchema from "./Components/SiteSchema";
import PageViewTracker from "./Components/Analytics";
import { PageSpinner } from "./Components/Status";

// Every page except Home is code-split so the first paint carries only what the home page needs.
const GCPage = lazy(() => import("./pages/gc"));
const CalendarPage = lazy(() => import("./pages/calendar"));
const PrivateToursPage = lazy(() => import("./pages/privatetours"));
const FAQPage = lazy(() => import("./pages/faq"));
const ContactPage = lazy(() => import("./pages/contact"));
const AboutUsPage = lazy(() => import("./pages/about"));
const FeaturedPage = lazy(() => import("./pages/featured"));
const FriendsPage = lazy(() => import("./pages/friends"));
const HiringPage = lazy(() => import("./pages/hiring"));
const ReviewsPage = lazy(() => import("./pages/reviews"));
const TourPage = lazy(() => import("./pages/tourpage"));
const BuyPage = lazy(() => import("./pages/buypage"));
const CheckoutPage = lazy(() => import("./pages/checkoutpage"));
const NotFoundPage = lazy(() => import("./pages/notfound"));

/** Client-side navigations keep the old scroll position; reset it like a page load would. */
function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const target = document.getElementById(hash.slice(1));
      if (target) {
        target.scrollIntoView();
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

const App = () => (
  <Router>
    <ScrollToTop />
    <SiteSchema />
    <PageViewTracker />
    <TopNav />
    <main id="main" className="site-main">
      <Suspense fallback={<PageSpinner />}>
        <Switch>
          <Route exact path={["/", "/index.html", "/tours"]} component={HomePage} />
          <Route exact path={["/gift-certificates", "/gift-certificates.html"]} component={GCPage} />
          <Route exact path={["/event-calendar", "/event-calendar.html"]} component={CalendarPage} />
          <Route exact path={["/private-tours", "/private-tours.html"]} component={PrivateToursPage} />
          <Route exact path={["/faq", "/faq.html"]} component={FAQPage} />
          <Route exact path={["/contact-us", "/contact-us.html"]} component={ContactPage} />
          <Route exact path={["/about-us", "/about", "/about-us.html", "/about.html"]} component={AboutUsPage} />
          <Route exact path="/featured" component={FeaturedPage} />
          <Route exact path="/friends" component={FriendsPage} />
          <Route exact path="/hiring" component={HiringPage} />
          <Route exact path="/reviews" component={ReviewsPage} />
          <Route exact path="/:slug/checkout/:performanceid" component={CheckoutPage} />
          <Route exact path="/:slug/buy" component={BuyPage} />
          <Route exact path="/:slug" component={TourPage} />
          <Route component={NotFoundPage} />
        </Switch>
      </Suspense>
    </main>
    <Footer />
  </Router>
);

export default App;
